import ParticipantDto from "types/ParticipantDto";
import ScriptDto from "types/ScriptDto";

export default class Participant implements ParticipantDto {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdOn: number;
  password: string;
  pin: string;
  scripts: ScriptDto[];
  searchable: boolean | null;

  constructor(participant: ParticipantDto) {
    this.id = participant.id;
    this.firstName = participant.firstName;
    this.lastName = participant.lastName;
    this.email = participant.email;
    this.createdOn = participant.createdOn;
    this.password = participant.password;
    this.pin = participant.pin;
    this.scripts = participant.scripts;
    this.searchable = participant.searchable;
  }

  getFulLName(): string {
    if (this.firstName && this.lastName)
      return `${this.firstName} ${this.lastName}`.trim();

    if (this.firstName) return this.firstName.trim();
    if (this.lastName) return this.lastName.trim();

    return "Unknown Participant";
  }

  getPiiSafeName(): string {
    if (this.firstName && this.lastName)
      return `${this.firstName} ${this.lastName[0]}.`.trim();

    if (this.firstName) return this.firstName.trim();
    if (this.lastName) return `${this.lastName[0]}.`.trim();

    return "Unknown Participant";
  }
}
